import gql from 'graphql-tag'
import { PRODUCT_REFERENCE_FRAGMENT } from './fragments.graphql'

export const GET_TOP_SELLING_PRODUCTS = gql`
  ${PRODUCT_REFERENCE_FRAGMENT}

  query GetTopSellingProducts(
    $categoryPath: String!
    $numberOfProducts: Int!
    $facets: [FacetParameterInput!]
  ) {
    topSellingProducts(
      categoryPath: $categoryPath
      numberOfProducts: $numberOfProducts
      facets: $facets
    ) {
      productReferences {
        ...ProductReference
      }
    }
  }
`
